export default __webpack_public_path__ + "static/media/ambient-bright-purple-orange.cac39630.jpg";